<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <path d="M26.06,31.03l-7.08-.03-9.23-9.37.09-10.78C9.83,5.66,12.56.1,20.2.1h4.99c5.91,0,10.04,4.43,10.04,10.77,0,5.44.02,10.15.02,10.15v.62s-9.2,9.4-9.2,9.4ZM20.23,28.01l4.57.02,7.45-7.61c0-1.45-.02-5.27-.02-9.55,0-4.72-2.76-7.77-7.04-7.77h-4.99c-6.65,0-7.36,5.43-7.36,7.77l-.08,9.55,7.48,7.59Z" fill="currentcolor"/>
    <polygon points="42.51 44.9 34.07 36.47 28.09 36.47 23.59 40.96 21.44 40.96 16.94 36.45 10.97 36.45 2.53 44.89 .41 42.77 9.73 33.45 18.18 33.45 22.52 37.79 26.86 33.47 35.31 33.47 44.59 42.73 42.51 44.9" fill="currentcolor"/>
  </svg>
</template>

<style scoped lang="scss">

</style>